import { useCallback, useEffect, useState } from 'react'

/**
 * Hook that copies text to the clipboard and tracks a transient "copied" state.
 * The copied flag resets to false after 2 seconds.
 * @param {string} text - The text to copy when `copy` is called
 * @returns {{ copied: boolean, copy: Function }}
 */
const useCopyToClipboard = (text) => {
  const [copied, setCopied] = useState(false)

  const copy = useCallback(() => {
    navigator.clipboard
      .writeText(text)
      .then(() => setCopied(true))
      .catch((err) => console.error('Failed to copy:', err))
  }, [text])

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [copied])

  return { copied, copy }
}

export default useCopyToClipboard
